import React, { useEffect, useRef } from "react";
import { FormEvent, ChangeEventHandler, useState } from "react";
import { toast } from "react-toastify";

const {
  baseUrl: baseURL,
  csrfToken,
  defaultCountry,
  countries,
  emailSuffix,
  accountEmails,
  logoBaseUrl
} = JSON.parse((document?.querySelector("#app") as any)?.dataset?.page).props;

const fileToDataString = (file: File) => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onerror = (error) => reject(error);
    reader.onload = () => resolve(reader.result as string);
  });
};

export default function ImageUploadInput({
  value,
  onChange,
}: {
  value: string;
  onChange: (url: string) => void;
}) {
  const [selectedImage, setSelectedImage] = useState<File>();
  const [previewImgUrl, setPreviewimgUrl] = useState<string>();

  useEffect(() => {
    if (!value) return;
    setPreviewimgUrl(`${logoBaseUrl}/${value.split('/').reverse()[0]}`);
  }, [value]);

  const [progress, setProgress] = useState<number>(0);

  const handleFileChange: ChangeEventHandler<HTMLInputElement> = async (
    event
  ) => {
    const file = event.target.files as FileList;
    setSelectedImage(file?.[0]);
    if (!file) {
      return;
    }
    try {
      const imgUrl = await fileToDataString(file?.[0]);
      setPreviewimgUrl(imgUrl);
    } catch (error) {
      console.log(error);
    }
  };
  const handleImageUpload = async () => {
    try {
      const formData = new FormData();
      if (selectedImage) {
        formData.append("file", selectedImage);
        const response = await fetch("/fileupload/companylogo/default", {
          method: "POST",
          headers: {
            "X-CSRF-TOKEN": csrfToken,
          },
          body: formData,
        });
        if (!response.ok) {
          toast.error("There is an error");
        }
        setProgress(0);
        const responseData: any = await response.json();
        console.log(responseData.files[0].url);
        if (responseData?.files[0]?.url) {
          toast.success("Image uploaded successfully");
          setSelectedImage(undefined);
          onChange(responseData.files[0].url);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fileInputRef: any = useRef(null);

  return (
    <div className="wrapper">
      {selectedImage && progress > 0 && (
        <div className="progress my-3">
          <div className="progress-bar progress-bar-info" role="progressbar">
            {progress}%
          </div>
        </div>
      )}
      <div
        className=" btn w-100 image_wrapper bg-secondary-subtle"
        style={{ minHeight: 100 }}
        onClick={() => {
          fileInputRef.current.click();
        }}
      >
        {previewImgUrl ? (
          <img src={previewImgUrl} alt="image" className="w-100" />
        ) : (
          "Select image"
        )}
      </div>

      <input
        ref={fileInputRef}
        type="file"
        onChange={handleFileChange}
        accept="image/*"
        className="d-none"
      />
      {selectedImage && (
        <button
          disabled={!selectedImage}
          type="button"
          onClick={handleImageUpload}
          className="btn btn-colored w-100"
        >
          Upload image
        </button>
      )}
    </div>
  );
}
